import { configureStore } from '@reduxjs/toolkit'
import filterReducer from './reducers/filterReducer'
import playerSlice from './reducers/playerReducer'
import userSlice from './reducers/userReducer'
import allPlayersReducer from './reducers/allPlayersReducer'
import candidateReducer from './reducers/candidateReducer'
import listReducer from './reducers/listReducer'
import bundleReducer from './reducers/bundleReducer'

const store = configureStore({
  reducer: {
    players: playerSlice,
    filter: filterReducer,
    user: userSlice,
    allPlayers: allPlayersReducer,
    candidates: candidateReducer,
    lists: listReducer,
    bundles: bundleReducer,
  },
})

export default store
